module.exports = __webpack_public_path__ + "resources/img/ico_toast_color.c8a265389eee7c3444150452539443f2.svg";